export enum BusinessCollection {
    SEARCH = 'search',
    SUBSCRIPTIONS = 'subscriptions',
}
